import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Text, StyleSheet, TouchableOpacity, ScrollView } from 'react-native'
import { BackHeader } from '../../../../assets/icons'
import { GetIcon } from '../../../../ui/atoms/GetIcon'
import { HeaderButton, Toolbar } from '../../../../ui/molecules/Layout'
import Wrapper from '../../Wrapper'
import { ProjectAlertForMobile } from './AlertForMobile'
import { Table } from './DesktopScreen'

export const ToolbarLeft = ({ navigation }) => {
  return (
    <HeaderButton
      icon={
        <GetIcon
          icon={<BackHeader height="20" width="20" />}
          onPress={() => navigation.goBack()}
        />
      }
    />
  )
}

export const MobileScreen = (props) => {
  const { t } = useTranslation('global')
  const { navigation } = props
  const [visible, setVisible] = useState(false)
  return (
    <Wrapper
      toolbar={
        <Toolbar
          headerStyle={{
            marginBottom: 0,
            borderBottomWidth: 1,
            borderBottomColor: '#E6EBEE',
          }}
          leftComponent={<ToolbarLeft navigation={navigation} />}
        />
      }
    >
      <Text style={styles.title}>{t('SelectProject.title-mobile')}</Text>
      <Text style={styles.subtitle}>{t('SelectProject.subtitle-mobile')}</Text>
      <TouchableOpacity onPress={() => setVisible(true)}>
        <Text style={styles.link}>
          {t('SelectProject.how-to-create-project')}
        </Text>
      </TouchableOpacity>
      <ScrollView>
        <Table {...props} />
      </ScrollView>
      <ProjectAlertForMobile
        visible={visible}
        setVisible={setVisible}
        title={t('SelectProject.how-to-create-project-title')}
      />
    </Wrapper>
  )
}

const styles = StyleSheet.create({
  title: {
    marginTop: 16,
    fontWeight: '700',
    fontSize: 20,
    lineHeight: 28,
    marginBottom: 10,
  },
  subtitle: {
    fontWeight: '400',
    fontSize: 14,
    lineHeight: 20,
    marginBottom: 15,
    color: '#19262F',
  },
  link: {
    fontSize: 14,
    fontWeight: '600',
    lineHeight: 20,
    color: '#00A0F3',
    textDecorationLine: 'underline',
    marginBottom: 15,
  },
})
